export const SLIDES_NUMBER_SUPPORTED = 3;
